import Repository from "../Repository";
import SiteRepository from "./siteRepository";

const resource = "/environments";
const siteResource = SiteRepository.getResource();
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getEnvironment(environmentId){
        return Repository.get(`${resource}/${environmentId}`);
    },
    createEnvironment(json){
        return Repository.post(`${resource}`,json);
    },
    updateEnvironment(environmentId,json){
        return Repository.put(`${resource}/${environmentId}`,json);
    },
    deleteEnvironment(environmentId){
        return Repository.delete(`${resource}/${environmentId}`);
    },
    getSites(environmentId){
        return Repository.get(`${resource}/${environmentId}/${siteResource}`);
    },
    addSite(environmentId,siteId){
        return Repository.post(`${resource}/${environmentId}/${siteResource}/${siteId}`);
    },
    removeSite(environmentId,siteId){
        return Repository.delete(`${resource}/${environmentId}/${siteResource}/${siteId}`);
    }
}